import { Observable } from 'rxjs/Observable'
import { combineEpics } from 'redux-observable'
import queryString from 'query-string'

import { api } from './api'
import * as actions from './actions'

const regenerateCode = (action$) => {
  return action$
    .ofType(actions.regenerateCode.toString())
    .mergeMap(() => {
      return api
        .regenerateCode()
        .map(actions.regenerateCodeSuccess)
        .startWith(actions.regenerateCodePending())
        .catch(() => Observable.of(actions.regenerateCodeFailed()))
    })
}

const regenerateCodeSuccess = (action$) => {
  return action$
    .ofType(actions.regenerateCodeSuccess.toString())
    .pluck('payload')
    .do(({ authorizationCode }) => {
      const redirectUri = localStorage.getItem('hyfy_redirect_uri')
      const state = localStorage.getItem('hyfy_state')
      const hyfyUrl =  `${redirectUri}?${queryString.stringify({
        code: authorizationCode,
        state,
      })}`
      localStorage.removeItem('hyfy_state')
      localStorage.removeItem('hyfy_redirect_uri')
      window.location.replace(hyfyUrl)
    })
    .ignoreElements()
}

export const epic = combineEpics(regenerateCode, regenerateCodeSuccess)



// WEBPACK FOOTER //
// ./src/modules/auth/epic.js